import BidImage from '../../images/Bid.svg';
import LearnImage from '../../images/Learn.svg';
import RegisterImage from '../../images/Register.svg';
import LightboxVideo from './how-it-works-lightbox';

export default function HowItWorks() {
    return (
        <section id="how-it-works" className="desktop-wrapper">
            <div className="mdc-layout-grid__inner">
                <div className="mdc-layout-grid__cell--span-12">
                    <h2 className="kmx-typography--display-6 align-center">
                        Join your first auction
                    </h2>
                </div>
            </div>
            <div className="mdc-layout-grid__inner">
                <div className="show-desktop-inline-flex mdc-layout-grid__cell--span-2" />
                <div className="mdc-layout-grid__cell--span-2-desktop  mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-4-phone">
                    <span className="align-center how-it-works-image">
                        <img src={RegisterImage} alt="" />
                    </span>
                    <h3 className="kmx-typography--display-2 align-center m-s">Register</h3>
                    <p className="kmx-typography--body-3 align-center m-s">
                        Create an account, add unlimited buyers
                    </p>
                </div>
                <div className="show-tablet-desktop-inline-flex mdc-layout-grid__cell--span-1" />
                <div className="mdc-layout-grid__cell--span-2-desktop  mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-4-phone">
                    <span className="align-center how-it-works-image">
                        <img src={LearnImage} alt="" />
                    </span>
                    <h3 className="kmx-typography--display-2 align-center m-s">Connect</h3>
                    <p className="kmx-typography--body-3 align-center m-s">
                        Your auction representative will give you a call
                    </p>
                </div>
                <div className="show-tablet-desktop-inline-flex mdc-layout-grid__cell--span-1" />
                <div className="mdc-layout-grid__cell--span-2-desktop  mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-4-phone">
                    <span className="align-center how-it-works-image">
                        <img src={BidImage} alt="" />
                    </span>
                    <h3 className="kmx-typography--display-2 align-center m-s">Bid &amp; Buy</h3>
                    <p className="kmx-typography--body-3 align-center m-s">
                        Attend our auctions and build your inventory
                    </p>
                </div>
                <div className="show-desktop-inline-flex mdc-layout-grid__cell--span-2" />
            </div>
            <br />
            <hzn-stack space="base" align-x="center" align-y="center">
                <div className="kmx-button-width">
                    <hzn-button
                        variant="cta"
                        hzn-aria-label="Register to get started"
                        href={process.env.AUCTIONS_WCS_URL + '/register'}
                        full-width>
                        GET STARTED
                    </hzn-button>
                </div>
                <LightboxVideo></LightboxVideo>
            </hzn-stack>

            <div className="mdc-layout-grid__inner">
                <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                    <span className="align-center"></span>
                </div>
            </div>
        </section>
    );
}
